export default "__VITE_ASSET__Lb4eOAIG__"